module.exports ={
  props: ['step', 'members', 'api', 'language', 'translation', 'languages'],
  data () {
    return {
      selectedLanguage: {},
      visible: false
    }
  },
  created () {
    this.selectedLanguage = this.languages.find(item => item[0] === this.language) || []
  },
  methods: {
    setLanguage (item) {
      this.$emit('change', item[0])
      this.selectedLanguage = item
      this.close()
    },
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    }
  },
  template: `
    <click-outside :do="close" class="language">
      <div class="relative">
        <div @click="open" class="language__select d-flex align-items-center py-3 h-pointer relative" :class="visible === true ? 'language__select--is-open' : ''">
          <p>{{ selectedLanguage.length ? selectedLanguage[1] : translation['Select Language'] }}</p>
          <i class="icon-chevron-down h-text-grey-cl-300 ml-auto"></i>
        </div>
        <div class="language__options">
          <div
            v-if="visible"
            v-for="item in languages"
            :key="item[0]"
            @click="setLanguage(item)"
            class="language__option h-pointer"
          >{{ item[1] }}</div>
        </div>
      </div>
    </click-outside>
  `
}